import {Component, Input} from '@angular/core';
import {RouterService} from '@npck/libs/commons';
import {Path} from '../../path';

@Component({
    selector: 'af-recovery-status',
    standalone: false,
    templateUrl: './recovery-status.component.html',
    styleUrl: './recovery-status.component.scss',
})
export class RecoveryStatusComponent {
    @Input() iconType: RecoveryStatusIcon = 'success';
    @Input() titleText: string;
    @Input() subtitleText: string;

    constructor(private routerService: RouterService) {
    }

    goToLogin(): void {
        this.routerService.navigate(Path.LOGIN);
    }
}

export type RecoveryStatusIcon = 'success' | 'expired';
